export function compactMoney(amount) {
  const n = Number(amount);
  if (!Number.isFinite(n) || n <= 0) return null;
  return new Intl.NumberFormat("en-US", {
    style: "currency",
    currency: "EUR",
    notation: "compact",
    maximumFractionDigits: 1,
  }).format(n);
}

export function summarizeTransfers(transfers = []) {
  const records = [...transfers]
    .filter((t) => t?.date)
    .sort((a, b) => new Date(a.date).getTime() - new Date(b.date).getTime());
  const amount = (t) => {
    const n = Number(t?.amount);
    return Number.isFinite(n) && n > 0 ? n : null;
  };
  const valued = records.filter((t) => amount(t) != null);
  const latest = records[records.length - 1] || null;
  const latestPriced = valued[valued.length - 1] || null;
  const highest = valued.reduce((max, t) => Math.max(max, amount(t)), 0);
  return {
    count: records.length,
    latestMove: latest
      ? `${latest.fromteam?.name || latest.from?.name || "Unknown"} to ${latest.toteam?.name || latest.to?.name || "Unknown"}`
      : null,
    latestDate: latest?.date || null,
    latestValue: latestPriced ? compactMoney(amount(latestPriced)) : null,
    highestValue: highest > 0 ? compactMoney(highest) : null,
  };
}
